import { ApiBaseMidBack } from './base';
import { GreenProductViewModel } from './types/greenProductViewModel';

/**
 * @internal
 */
export class ApiReferentialGreenProduct extends ApiBaseMidBack {
  getReferentialGreenProduct() {
    return this.get<GreenProductViewModel[]>(`/green-product/list`);
  }
}
